<script>
	// A goods-return document: customer, returned models, unit price before VAT, totals and signatures.
	// Printing a page that has it prints only this document. With paper=true it also shows on screen as a page.
	import { VAT_PERCENT } from '../lib/format';

	export let title = 'החזרת סחורה';
	export let number = '';
	export let date = '';
	export let company = '';
	export let agent = '';
	export let customerName = '';
	export let customerNo = '';
	export let items = []; // { code, name, qty, price, doc_no, date }
	export let note = ''; // how the unit prices were set
	export let remarks = '';
	export let cartons = 0;
	export let paper = false;

	const round2 = (n) => Math.round(n * 100) / 100;
	const price = (n) => '₪' + (Number(n) || 0).toLocaleString('he-IL', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
	const day = (d) => (d ? d.slice(8, 10) + '/' + d.slice(5, 7) + '/' + d.slice(2, 4) : '');

	$: units = items.reduce((s, i) => s + Number(i.qty), 0);
	$: total = round2(items.reduce((s, i) => s + round2(Number(i.qty) * Number(i.price)), 0));
	$: vat = round2((total * VAT_PERCENT) / 100);
</script>

<div class="return-print" class:paper>
	<header class="p-head">
		<div>
			<h1>{title + (number ? ' מס׳ ' + number : '')}</h1>
			<div>{company}</div>
		</div>
		<div class="p-meta">
			<div>תאריך: {date}</div>
			{#if agent}<div>הוכן ע״י: {agent}</div>{/if}
		</div>
	</header>
	<div class="p-cust">
		<span>לקוח: <b>{customerName}</b> · מספר לקוח {customerNo}</span>
		{#if cartons}<span class="p-cartons">קרטונים: <b>{cartons}</b></span>{/if}
	</div>
	<table>
		<thead>
			<tr><th>#</th><th>דגם</th><th>תיאור</th><th>כמות</th><th>מחיר ליחידה</th><th>סה״כ</th><th>לפי חשבונית</th></tr>
		</thead>
		<tbody>
			{#each items as it, i}
				<tr>
					<td>{i + 1}</td>
					<td dir="ltr" class="code">{it.code}</td>
					<td>{it.name}</td>
					<td>{it.qty}</td>
					<td>{price(it.price)}</td>
					<td>{price(round2(it.qty * it.price))}</td>
					<td>{it.doc_no || ''}{#if it.date} · {day(it.date)}{/if}</td>
				</tr>
			{/each}
		</tbody>
		<tfoot>
			<tr><td colspan="3">סה״כ {units} יחידות</td><td colspan="2">סה״כ לפני מע״מ</td><td colspan="2">{price(total)}</td></tr>
			<tr><td colspan="3" /><td colspan="2">מע״מ {VAT_PERCENT}%</td><td colspan="2">{price(vat)}</td></tr>
			<tr class="grand"><td colspan="3" /><td colspan="2">סה״כ לזיכוי כולל מע״מ</td><td colspan="2">{price(round2(total + vat))}</td></tr>
		</tfoot>
	</table>
	{#if remarks}<p class="p-remarks"><b>הערות:</b> {remarks}</p>{/if}
	{#if note}<p class="p-note">{note}</p>{/if}
	<div class="p-sign"><span>חתימת הלקוח: ____________________</span><span>חתימת המקבל: ____________________</span></div>
</div>

<style>
	.return-print { display: none; color: #000; font-size: 14px; }
	.return-print.paper { display: block; background: #fff; border: 1px solid var(--line); border-radius: var(--radius); padding: 28px 32px; max-width: 960px; margin: 0 auto; box-shadow: var(--shadow); }
	.p-head { display: flex; justify-content: space-between; align-items: flex-start; border-bottom: 2px solid #000; padding-bottom: 8px; margin-bottom: 10px; }
	.p-head h1 { margin: 0 0 2px; font-size: 22px; }
	.p-meta { text-align: left; }
	.p-cust { display: flex; justify-content: space-between; gap: 16px; font-size: 15px; margin-bottom: 10px; }
	.p-cartons { border: 2px solid #000; padding: 2px 10px; font-size: 16px; }
	table { width: 100%; border-collapse: collapse; }
	th, td { border: 1px solid #999; padding: 6px; text-align: right; }
	th { background: #eee; font-weight: 700; }
	.code { text-align: left; }
	tfoot td { border: 0; padding: 4px 6px; }
	tfoot .grand td { font-weight: 800; font-size: 15px; border-top: 2px solid #000; }
	.p-remarks { margin: 12px 0 0; }
	.p-note { font-size: 11px; color: #333; margin-top: 10px; }
	.p-sign { display: flex; justify-content: space-between; margin-top: 40px; font-size: 13px; }

	/* printing a page with this document prints only the document */
	@media print {
		:global(.topbar), :global(.tabbar), :global(.backdrop), :global(.modal) { display: none !important; }
		:global(.page > :not(.return-print)) { display: none !important; }
		:global(body) { background: #fff; }
		:global(.page) { padding: 0 !important; max-width: none !important; }
		.return-print, .return-print.paper { display: block; border: 0; border-radius: 0; padding: 0; box-shadow: none; max-width: none; font-size: 13px; }
	}
</style>
